import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="drawer"
export default class extends Controller {
	static classes = ["closed", "opened"];
	static targets = ["panel", "backdrop"];

	open() {
		this.backdropTarget.classList.remove("hidden");
		this.backdropTarget.classList.add("block");
		console.log(this.openedClasses);
		this.panelTarget.classList.remove(...this.closedClasses);
		this.panelTarget.classList.add(...this.openedClasses);
	}

	close() {
		this.panelTarget.classList.remove(...this.openedClasses);
		this.panelTarget.classList.add(...this.closedClasses);

		this.backdropTarget.classList.add("hidden");
	}
}
